// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./lib/css";
import "./lib/script";
import "./lib/global";

import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import i18n from "./lang";
import app_common_css from "./styles/app.scss";
import contentmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'
import "bootstrap/dist/css/bootstrap.css"
import "vue-select/dist/vue-select.css";

// import { SchedulePlugin } from '@syncfusion/ej2-vue-schedule';

// Vue.use(SchedulePlugin);

Vue.use(contentmenu)
import BootstrapVue from "bootstrap-vue";
import VueTimepicker from "vue2-timepicker";
import vSelect from "vue-select";
import VueQRCodeComponent from 'vue-qrcode-component'

Vue.component("v-select", vSelect);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueTimepicker);
Vue.component('qr-code', VueQRCodeComponent)
/* eslint-disable no-new */
const app = new Vue({
  el: "#app",
  i18n,
  store,
  app_common_css,
  router,
  components: { App },
  template: "<App/>"
});

export default app;



// WEBPACK FOOTER //
// ./src/main.js